import React from 'react';
import Auth from 'works/legacy/lib/auth';
import {
  defaultLoginRedirectPath,
  EntityTypeType,
} from 'works/legacy/lib/default-login-redirect-path';
import { AuthTemplateCentralizedContainer } from '@identity/components';
import { useRedirectPath } from '@identity/hooks/use-redirect-path';
import { randomAccountColor } from '@identity/services';
import { Navigate } from '@common/components';
import { useParams } from '@common/hooks';

export function SignInSuccessPage() {
  const {
    email: encodedEmail,
    identityToken,
    ssoToken,
    entityType,
    membershipId,
  } = useParams<{
    email: string;
    identityToken: string;
    ssoToken: string;
    entityType: EntityTypeType;
    membershipRole: string;
    membershipId: string;
  }>();

  const redirectPath = useRedirectPath();
  const email = decodeURIComponent(encodedEmail || '');

  const idsToken = identityToken || ssoToken || '';

  const storedMembershipId = Auth.getPendingSsoMembershipId();

  const effectiveEntityType = entityType || 'Organization';

  const userState = {
    identityToken: idsToken,
    email,
    entityType: effectiveEntityType,
    membershipId: storedMembershipId || membershipId || '', // Fallback to URL param for IdP-initiated SSO.
    // It will be populated by the AuthGuard query
    name: 'loading',
    entityName: 'loading',
    path: redirectPath || defaultLoginRedirectPath(effectiveEntityType),
    color: randomAccountColor({ exclude: Auth.colorsBeingUsed() }),
  };

  Auth.store(userState);
  Auth.clearPendingSsoMembershipId();

  const shouldRedirect = Boolean(idsToken);

  return shouldRedirect ? (
    <AuthTemplateCentralizedContainer>
      <Navigate to={userState.path} />
    </AuthTemplateCentralizedContainer>
  ) : null;
}
